import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, map } from 'rxjs';
import { environment } from '../../environment';

@Component({
  selector: 'lib-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SiteFooterComponent implements OnInit {
  gdprUrl$: Observable<string>;
  ansokanGuideUrl$: Observable<string>;

  public env = inject(environment);
  private translocoService = inject(TranslocoService);

  ngOnInit() {
    this.gdprUrl$ = this.translocoService.langChanges$.pipe(
      map((lang) => {
        return this.env.externalLinks.gdpr[lang];
      }),
    );
    this.ansokanGuideUrl$ = this.translocoService.langChanges$.pipe(
      map((lang) => {
        return this.env.externalLinks.ansokanGuide[lang];
      }),
    );
  }
}
